import headerImg from '../../../assets/developers/devbanner.svg'

import ease from '../../../assets/developers/ease.svg'
import growth from '../../../assets/developers/growth.svg'
import speed from '../../../assets/developers/speed.svg'

import whyChoose from '../../../assets/developers/whyChoose.svg'


export const headerData = {
    title: 'Python',
    title2: 'Developers',
    desc: 'Python is a popular high-level programming language that is widely used for web development, data analysis, artificial intelligence, machine learning, and scientific computing. It has a simple and easy-to-learn syntax, making it a popular choice for beginners and experienced programmers alike. Python is an interpreted language, which means that it does not require compilation before execution, making it easy to write, test, and debug code.',
    points: [
        'Quick deployment',
        'An active community with open-source solutions',
        'Shorter time-to-market circle',
    ],
    img: headerImg
}

export const achiveData = {
    title1: 'What can you Achieve with the right',
    title2: 'Python Developers?',
    desc: "You need a Python team that never compromises on your project’s success determinants. Let's find out what a field-proven team looks like",
    cards: [
        {
            title: 'Growth with Confidence',
            desc: 'Start small but go big with CodeZone’s Python developers, who leverage seamless and cost-effective cloud computing tools to expand your user base.',
            img: ease
        },
        {
            title: 'Ease of Flexibility',
            desc: 'Node-to-node technology facilitates Python developers to smoothly integrate changes without altering the core programming source, contributing to easier maintenance.',
            img: growth
        },
        {
            title: 'Speed and Performance',
            desc: 'Python experts integrate uninterrupted speed and performance to handle high traffic, making Python an ideal framework for developing user-centric apps.',
            img: speed
        },


    ]
}

export const partnerData = {
    title1: 'Partner With CodeZone for Future-forward',
    title2: 'Python App Development Services',

    cards: [
        {
            title: 'Truly Agile Procedures',
            desc: "CodeZone's Python developers follow the time-tested agile practices throughout the software development life cycle — ensuring efficiency and transparency.",
        },
        {
            title: 'Custom Python development services',
            desc: 'CodeZone is a houseful of Python experts and tech stack that fit faultlessly with your product and company culture.',
        },
        {
            title: 'Market competitive Rates',
            desc: "We provide silicon-valley level Python experts under budget-friendly pricing. With us, you wouldn't have to worry about your budget and the quality, because we care for both.",
        },
        {
            title: 'Dedicated Python Mobile App Development Teams',
            desc: "The dedicated development team co-acts with your in-house team. Borders, languages, or cultures never stop us from delivering a global enterprise-level product.",
        },


    ]
}

export const whyChooseData = {
    title: 'Python',
    desc: 'Easy. Awesome. Powerful. Fast. Flexible. Fun. – All under Python Umbrella.',
    img: whyChoose,
    cards: [
        {
            title: 'High Performance',
            desc: 'Outperform the competition with the single-threaded and event-driven architecture of Python.'
        },
        {
            title: 'Easy Scalability',
            desc: 'Handle a huge number of concurrent connections and develop lightweight systems with Python.'
        },
        {
            title: 'Microservices',
            desc: 'Build powerful microservice-based web applications with Python developers.'
        },
        {
            title: 'Custom Software Development',
            desc: 'Leverage built-in API through Python as it can be easily extended and customized.'
        },
        {
            title: 'Fast Time-to-Market',
            desc: 'Speed up the development process with multiple frameworks and libraries of Python.'
        },
        {
            title: 'Community Support',
            desc: 'Expect extensive support from hawk-eyed developers of the Python community.'
        },
    ]
}

export const HowToData = {
    title : 'Python developers',
    desc : 'A meticulous process for impeccable product launch without any delays',
}

export const FAQData = [
    {
        question: 'What is Python used for?',
        answer: 'Python is a versatile language that is used for a wide range of purposes, including web development, data analysis, artificial intelligence, machine learning, scientific computing, and more.'
    },
    {
        question: 'Is Python easy to learn?',
        answer: 'Yes, Python has a simple and easy-to-learn syntax, which makes it a popular choice for beginners and experienced programmers alike.'
    },
    {
        question: 'What are the advantages of using Python?',
        answer: "Some advantages of using Python include its ease of use, versatility, large and active community, and availability of a wide range of libraries and tools. Python is also an interpreted language, which means that it does not require compilation before execution, making it easy to write, test, and debug code."
    },
 

]